import EventEmitter from 'events';

class EventBus {
  private instance = new EventEmitter();
  private eventKeyList: string[] = [
    'permissionDenied', // 没有权限时通知返回错误页
  ];

  getEventList() {
    return this.eventKeyList;
  }

  once(key: string, callback: () => void) {
    this.instance.once(key, callback);
  }

  on(key: string, callback: () => void) {
    // 添加event必须在eventKeyList中声明，并备注使用场景，避免event被乱用
    if (!this.eventKeyList.includes(key)) {
      console.error('注册的事件名称未声明！');
    }
    this.instance.on(key, callback);
  }

  emit(key: string, ...args: any[]) {
    this.instance.emit(key, ...args);
  }

  remove(key: string, callback: () => void) {
    this.instance.removeListener(key, callback);
  }

  removeAll(keyArr: string) {
    this.instance.removeAllListeners(keyArr);
  }
}
export default new EventBus();
